export default "__VITE_ASSET__CJiOaC3J__"